<template>
  <div class="event-times">
    <div v-for="i in limit" :key="i" class="event-time mb-3">
      <div v-if="limit > 1" class="day-tag">Day {{ i }}</div>
      <TimeField
        label="Start Time"
        :name="`times[${i - 1}][start_time]`"
        :value="!!times[i - 1] ? times[i - 1].start_time : '08:00'"
      />
      <div class="separator">/</div>
      <TimeField
        label="End Time"
        :name="`times[${i - 1}][end_time]`"
        :value="!!times[i - 1] ? times[i - 1].end_time : '16:00'"
      />
      <input type="hidden" :name="`times[${i - 1}][order]`" :value="i" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    start: { type: [Date, String], default: new Date() },
    end: { type: [Date, String], default: new Date() },
    value: { type: Array, default: () => [] },
    sameTimeEachDay: { type: Boolean, default: false },
  },

  data() {
    return {
      times: [],
    };
  },

  computed: {
    startDate() {
      var start = this.start;
      if (!start) {
        return null;
      } else if (typeof start == "string") {
        return new Date(start);
      } else {
        return start;
      }
    },
    endDate() {
      var end = this.end;
      if (!end) {
        return null;
      } else if (typeof end == "string") {
        return new Date(end);
      } else {
        return end;
      }
    },
    limit() {
      if (!!this.startDate && !!this.endDate && !this.sameTimeEachDay) {
        var startDate = this.startDate;
        var endDate = this.endDate;
        startDate.setHours(0, 0, 0);
        endDate.setHours(0, 0, 0);
        return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
      } else {
        return 1;
      }
    },
  },

  watch: {
    value(val) {
      this.times = val;
    },
    times(val) {
      this.$emit("input", val);
    },
  },

  created() {
    this.times = this.value;
  },
};
</script>